/**
 * @constant emetSteps
 * @description
 * Define los pasos o secciones que componen el flujo de la certificación EMET.
 * Incluye secciones académicas, pausas (BREAK) y el cierre del examen.
 *
 * @type {Array<Object>}
 * @property {string} icon - Nombre del ícono representativo del paso.
 * @property {string} label - Etiqueta visible del paso (ej. Section 1, BREAK).
 * @property {string} sectionDesc - Descripción de la sección que aparece en la UI.
 */
export const emetSteps = [
	{
		icon: 'book-open',
		label: 'Welcome',
		sectionDesc: 'Welcome'
	},
	{
		icon: 'book-open',
		label: 'Section 1',
		sectionDesc: 'Language Proficiency and its use'
	},
	{
		icon: 'clock',
		label: 'BREAK',
		sectionDesc: 'BREAK'
	},
	{
		icon: 'book-open',
		label: 'Section 2',
		sectionDesc: 'Metodology Education Methodologies for English Language Teaching'
	},
	{
		icon: 'clock',
		label: 'BREAK',
		sectionDesc: 'BREAK'
	},
	{
		icon: 'book-open',
		label: 'Section 3',
		sectionDesc: 'Types of Learners and Lesson planning, resources, and evaluation'
	},
	{
		icon: 'clock',
		label: 'BREAK',
		sectionDesc: 'BREAK'
	},
	{
		icon: 'book-open',
		label: 'Section 4',
		sectionDesc: 'Digital Area in English Language Teaching'
	},
	{
		icon: 'thumbs-up',
		label: 'Done',
		sectionDesc: 'DONE'
	}
];